export default __webpack_public_path__ + "static/stepThreeMeasureYourFinger-ce4a9c49e0ca1bc84edb536649d2c458.png";